module.exports = __webpack_public_path__ + "static/bsky-e219a96b43c195a50e03a5fc29961c2d.jpg";